import React from 'react';
import Box from '@amzn/awsui-components-core/box';
import type { PnlQueryStats } from 'src/components/star-grid/queryStats.types';
import { useReportQueryStats } from 'src/components/star-grid/hooks/useReportQueryStats';
import { useStarGridText } from 'src/components/star-grid/hooks/useStarGridText';
import { reportQueryStats } from 'src/components/star-grid/utils/reportQueryStats';
import styles from 'src/components/star-grid/views/styles/ReportDetailView.module.scss';

/** Where the engine counters for the last load can be read, once someone opens the stats. */
export interface QueryStatsSource {
  readonly reportId?: string;
  readonly queryId?: string | null;
  readonly factTable?: string | null;
}

/** The last load's counters; the engine profile is fetched only when the panel opens. */
export const ReportStatsSummary: React.FC<{ serverMs?: number | null; queryStats?: PnlQueryStats; source?: QueryStatsSource }> = ({
  serverMs,
  queryStats,
  source
}) => {
  const text = useStarGridText();
  const fetched = useReportQueryStats(source?.reportId, source?.queryId, false, source?.factTable);
  const { details } = reportQueryStats(serverMs, queryStats ?? fetched, text);
  return (
    <Box>
      <ul className={styles.statsSummary}>
        <li>{text('reportLoadTimeHelp')}</li>
        {details.map((line) => (
          <li key={line}>{line}</li>
        ))}
      </ul>
    </Box>
  );
};
